import {Controller} from 'react-hook-form'
import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import ColorPicker from 'lib/ui/ColorPicker'
import Divider from 'lib/ui/ConfigPanel/Divider'
import Title from 'lib/ui/ConfigPanel/Title'
import Slider from 'lib/ui/Slider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'

export default function DescriptionConfig() {
  const saveTemplate = useSaveTemplate()
  const {login, textColor} = useTemplate()
  const v = useAttendeeVariables()
  const addTranslation = useAddTranslation()

  const descriptionTextColor =
    login.passwordReset.descriptionTextColor ||
    login.description.color ||
    textColor
  const descriptionFontSize =
    login.passwordReset.descriptionFontSize ?? login.description.fontSize

  const save = (data: any) => {
    const description = replaceAtPath(
      data,
      'login.passwordReset.description',
      '{{password_reset_description}}',
    )
    saveTemplate({
      ...data,
      localization: addTranslation({
        password_reset_description: description ?? '',
      }),
    })
  }

  const {
    form: {register, control},
  } = useConfig()

  return (
    <Config title="Description" onSave={save}>
      <SettingsPanel>
        <Title>Description</Title>
        <TextField
          name="login.passwordReset.description"
          defaultValue={v(login.passwordReset.description)}
          label="Text"
          fullWidth
          inputProps={{
            'aria-label': 'set form description',
            ref: register,
          }}
        />
        <Divider />
        <Title>Success Mesage</Title>
        <TextField
          name="login.passwordReset.successMessage"
          defaultValue={login.passwordReset.successMessage}
          label="Text"
          fullWidth
          inputProps={{
            'aria-label': 'success message',
            ref: register,
          }}
        />
      </SettingsPanel>
      <StylingPanel>
        <Controller
          name="login.passwordReset.descriptionTextColor"
          defaultValue={descriptionTextColor}
          control={control}
          render={({value, onChange}) => (
            <ColorPicker
              label="Description Text Color"
              color={value}
              onPick={onChange}
              aria-label="description text color"
            />
          )}
        />
        <Controller
          name="login.passwordReset.descriptionFontSize"
          defaultValue={descriptionFontSize}
          control={control}
          render={({value, onChange}) => (
            <Slider
              valueLabelDisplay="auto"
              aria-label="description font size"
              value={value}
              onChange={onChange}
              step={1}
              min={5}
              max={50}
              label="Description Font Size"
            />
          )}
        />
      </StylingPanel>
    </Config>
  )
}
